<template>
  <div v-click-outside="() => (this.show = false)">
    <div class="dropdown-checkbox" @click="showDropdown">
      <div class="overselect"></div>
      <select class="c-form-input input-selection form-control">
        <option value="">
          {{
            selected && selected.length
              ? `Đã chọn ${selected.length} Truck ID`
              : `Vui lòng chọn`
          }}
        </option>
      </select>
    </div>
    <div class="multiselect" v-if="show">
      <ul>

        <li v-for="(option, index) in list" :key="option.id">
          <input
            type="checkbox"
            :disabled="disabled"
            @click="onCheck(option)"
            :id="index"
            :checked="selected.includes(option.id)"
          />
          <label class="ml-2 mb-0" :for="index">{{ option.id }}</label>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import ClickOutside from "vue-click-outside";
export default {
  directives: {
    ClickOutside,
  },
  name: "SelectCheckbox",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    
    options: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      selected: [],
      list: [],
    };
  },
  created() {},
  mounted() {
    if (this.value && this.value.length) {
      this.value.forEach((item) => {
        this.selected.push(item.id);
      });
    }else{
      this.loadList()
    }
  },
  computed: {},
  methods: {
    onCheck(item) {
      if (this.selected.includes(item.id)) {
        this.selected = this.selected.filter((id) => id !== item.id);
      } else {
        this.selected.push(item.id);
      }
      this.$emit(
        "input",
        this.list.filter((item) => this.selected.includes(item.id))
      );
    },

    showDropdown() {
      this.show = !this.show;
    },

    loadList() {
      if (this.selected && this.selected.length) {
        this.list = [];
        this.options.forEach((item) => {
          console.log(item);

          if (this.selected[0].slice(0, -2) == item.id.slice(0, -2)) {
            this.list.push(item);
          }
        });
      } else {
        this.list = JSON.parse(JSON.stringify(this.options));
      }
    },
  },

  watch: {
    selected(n, o) {
      this.loadList();
    },
    // options(val) {
    //   console.log(val)
    //   const newArray = [];
    //   val.forEach((item) => {
    //     newArray.push({
    //       value: item.value,
    //       id: item.id,
    //       status: this.checkStatus(item.id, val),
    //     });
    //   });
    //   this.list = newArray;
    // },
  },
};
</script>
<style lang="scss">
.dropdown-checkbox {
  position: relative;
  cursor: pointer;
  &:before {
    content: "";
    position: absolute;
    right: 14px;
    top: 0;
    bottom: 0;
    width: 14px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAAAmElEQVQokZ3SwQ3CIBTG8X+7gI6BNzawq3jnoOyBMcEBOooj1BNXV3ACzDOSGEuL8CWEvPeR34lOebcFRkDulD31uQNDF2Nkdz1r4AZsGiDJE9DB2EcvUzB2Ev1TtGCDYDL0aduIJmxKi/67rURn2AysRI+/WBb8Ez0EY8dckQUL6CK2Ci6gpzXsHfmHpaO808q7S/FtjLwAmwh101zduSgAAAAASUVORK5CYII=)
      center / contain no-repeat;
  }
}

.multiselect {
  position: relative;

  ul {
    background-color: white;
    border: 1px solid #2b938c;
    border-radius: 0 0 3px 3px;
    border-radius: 3px;
    left: 0px;
    position: absolute;
    top: 0rem;
    width: 100%;
    padding: 1rem 0;
    min-width: 250px;
    list-style: none;
    z-index: 100;
    label {
      font-size: 14px;
    }
    li {
      display: flex;
      text-align: center;
      flex-direction: row;
      align-items: center;

      padding: 0.7rem 1rem;
      &:hover {
        background-color: rgba(43, 147, 140, 0.12) !important;
      }
    }
  }
}

.overselect {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
